import React from 'react';
import './pullQuote.scss';

const PullQuote = ({ quote, color, author }) => {
  return (
    <div className="pullQuote">
      <div className="pullQuote__text">
        <p className={color === 'brown' ? 'pq--brown' : 'pq'}>{quote}</p>
        {author && <p className="source">{author}</p>}
      </div>
    </div>
  );
};

export default PullQuote;
